import React, { useState, useRef, useEffect } from 'react';

/**
 * Tooltip — bulle d'explication au tap/hover
 * Usage : <Tooltip text="Mon explication"><span>élément</span></Tooltip>
 * Ou avec icône info : <Tooltip text="..." icon />
 */
const Tooltip = ({ text, children, icon = false, position = 'top' }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  /* Fermer en cliquant ailleurs */
  useEffect(() => {
    if (!visible) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setVisible(false);
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [visible]);

  const posStyles = {
    top:    { bottom: 'calc(100% + 8px)', left: '50%', transform: 'translateX(-50%)' },
    bottom: { top:    'calc(100% + 8px)', left: '50%', transform: 'translateX(-50%)' },
    left:   { right:  'calc(100% + 8px)', top: '50%',  transform: 'translateY(-50%)' },
    right:  { left:   'calc(100% + 8px)', top: '50%',  transform: 'translateY(-50%)' },
  };

  const arrowStyles = {
    top:    { bottom: -5, left: '50%', transform: 'translateX(-50%) rotate(45deg)' },
    bottom: { top:    -5, left: '50%', transform: 'translateX(-50%) rotate(45deg)' },
    left:   { right:  -5, top: '50%',  transform: 'translateY(-50%) rotate(45deg)' },
    right:  { left:   -5, top: '50%',  transform: 'translateY(-50%) rotate(45deg)' },
  };

  return (
    <span
      ref={ref}
      style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
      onClick={(e) => { e.stopPropagation(); setVisible(v => !v); }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {/* Contenu ou icône ℹ */}
      {icon ? (
        <span style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: 16, height: 16, borderRadius: '50%',
          background: 'var(--md-outline)',
          color: 'var(--md-text-secondary)',
          fontSize: '0.65rem', fontWeight: 800,
          cursor: 'help', flexShrink: 0,
          userSelect: 'none',
        }}>
          i
        </span>
      ) : children}

      {/* Bulle */}
      {visible && (
        <span style={{
          position: 'absolute',
          ...posStyles[position],
          zIndex: 9999,
          background: '#1e293b',
          color: '#f1f5f9',
          fontSize: '0.78rem',
          fontWeight: 500,
          lineHeight: 1.5,
          padding: '0.55rem 0.8rem',
          borderRadius: '10px',
          whiteSpace: 'normal',
          width: 220,
          boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
          pointerEvents: 'none',
          textAlign: 'left',
        }}>
          {/* Flèche */}
          <span style={{
            position: 'absolute',
            ...arrowStyles[position],
            width: 10, height: 10,
            background: '#1e293b',
            pointerEvents: 'none',
          }} />
          {text}
        </span>
      )}
    </span>
  );
};

export default Tooltip;